import axios from "axios";
import { getConfig } from '../configService';

export class MasterDataService {
    static get masterDataServiceBaseUrl() {
        if((window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1') && getConfig().localhostApi) {
            return "http://localhost:5048/v1";
        }
        return `${getConfig().apiBaseUrl}/master-data/v1`;
    }

    static async getAllCategories() {
        try {
            var response = await axios(this.masterDataServiceBaseUrl + '/Categories');
            return response.data || [];
        } catch (error) {
            console.error("Failed to load categories", error);
            return [];
        }
    }

    static async getListOfServices(category) {
        try {
            var response = await axios(this.masterDataServiceBaseUrl + '/Categories/' + category + '/services');
            return await response.data;
        } catch (error) {
            console.log(error)
        }
    }

    static async getCategoryConfigs() {
        try {
            const response = await axios(this.masterDataServiceBaseUrl + '/Categories/config');
            return response.data || [];
        } catch (error) {
            console.error("Failed to load category configs", error);
            return [];
        }
    }

    static async getVisibleCategories() {
        try {
            const [categories, configs] = await Promise.all([this.getAllCategories(), this.getCategoryConfigs()]);
            const hidden = new Set((configs || []).filter((c) => c && c.hidden).map((c) => c.key));
            return (categories || []).filter((name) => !hidden.has(name));
        } catch (error) {
            console.error("Failed to load visible categories", error);
            try { return await this.getAllCategories(); } catch { return []; }
        }
    }
}